var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-block"},[_c('div',{staticClass:"d-flex flex-column flex-md-row justify-content-start align-items-center p-2 p-md-4 rounded-top border-bottom",class:_vm.qwarkBorder},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }